import FlipBook from './Flipbook';
import '../styles/Test2.css';
import page1 from '../imagenes/portadaPDFProcesos/10.jpg';
import page2 from '../imagenes/portadaPDFProcesos/0.jpg';
import page3 from '../imagenes/portadaPDFProcesos/ACTA_DE_ADJUDICACION_DE_LA_BUENA_PRO.jpg';
import page4 from '../imagenes/portadaPDFProcesos/ACTA_DE_RECEPCION_DE_PROPUESTAS.jpg';
import page5 from '../imagenes/portadaPDFProcesos/Ampliacion.jpg';

const pages = [
  page1,
  page2,
  page3,
  page4,
  page5
];

function Test2() {
  return <FlipBook pages={pages} width="900px" height="600px" />;
}

export default Test2;
